import { ReactElement, ReactNode } from 'react';
import {
  ButtonIcon,
  Menu,
  MenuItem,
  MenuTrigger,
  Tooltip,
  TooltipTrigger,
} from '@backstage/ui';
import './MenuItem.css';

export type BUIMenuActionItem = {
  id: string;
  label: ReactNode;
  icon?: ReactNode;
  onClick: () => void;
  isDisabled?: boolean;
  isHidden?: boolean;
  itemClassName?: string;
};

type BUIMenuItemProps = {
  items: BUIMenuActionItem[];
  tooltip?: ReactNode;
  triggerLabel?: string;
  triggerIcon?: ReactElement;
  buttonId?: string;
  menuId?: string;
  triggerTestId?: string;
};

export const BUIMenuItem = ({
  items,
  tooltip,
  triggerLabel = 'More actions',
  triggerIcon,
  buttonId,
  menuId,
  triggerTestId,
}: BUIMenuItemProps) => {
  const visibleItems = items.filter(item => !item.isHidden);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <MenuTrigger>
      {tooltip ? (
        <TooltipTrigger>
          <ButtonIcon
            variant="tertiary"
            icon={triggerIcon}
            aria-label={triggerLabel}
            id={buttonId}
            aria-controls={menuId}
            aria-haspopup="true"
            size="small"
            data-testid={triggerTestId}
          />
          <Tooltip>{tooltip}</Tooltip>
        </TooltipTrigger>
      ) : (
        <ButtonIcon
          variant="tertiary"
          icon={triggerIcon}
          aria-label={triggerLabel}
          id={buttonId}
          aria-controls={menuId}
          aria-haspopup="true"
          size="small"
          data-testid={triggerTestId}
        />
      )}
      <Menu id={menuId}>
        {visibleItems.map(item => (
          <MenuItem
            key={item.id}
            onAction={item.onClick}
            isDisabled={item.isDisabled}
            className={item.itemClassName}
          >
            {item.icon}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </MenuTrigger>
  );
};
